<template>
	<div class="layout">
		<div id="layout-title">
			<div class="layout-title-left">
				<img src="/static/imgs/danju.png" class="jxyd-imgicon" />
				其它入库单管理
			</div>
			<div class="layout-title-right">
				<button class="jxyd-button" title="新建单据" @click="addEnterStoreList" style="margin-right:10px;"
					v-show="permission.isAdd">
					<Icon type="md-add-circle" size='18' /> 新建
				</button>
				<a href="javascript:void(0)" @click="handleDownLoad" class="jxyd-button" v-show="permission.isExport">
					<Icon type="md-open" size='18' /> 导出
				</a>

				<Dropdown style="margin-left:10px;" @on-click="batchFunc">
					<a href="javascript:void(0)" class="jxyd-a">
						批量操作
						<Icon type="ios-arrow-down"></Icon>
					</a>
					<DropdownMenu slot="list">
						<DropdownItem name='batchDele' v-show="permission.isDelete" class="dropdown-item">
							<Icon type="md-trash" size='18' /> 删除
						</DropdownItem>
						<DropdownItem name="batchAudit" v-show="permission.isBatchAudit" class="dropdown-item">
							<Icon type="md-checkbox-outline" size='18' /> 批量审核
						</DropdownItem>
						<DropdownItem name="setPrintTemp" class="dropdown-item">
							📄
							<span>配置打印模版</span>
						</DropdownItem>
						<DropdownItem name="batchPrint" v-show="permission.isBatchPrint" class="dropdown-item">
							<Icon type="md-print" size='18' /> 批量打印
						</DropdownItem>
					</DropdownMenu>
				</Dropdown>
			</div>
		</div>
		<div id="layout-box">
			<div id="box-search">
				<Form ref="formSearch" :label-width="90" :model="searchItems" inline>
					<Row :gutter="16">
						<Col :lg="8" :md="24">
						<FormItem label="单据编号" style="width:100%">
							<Input type="text" v-model="searchItems.code" placeholder="请输入其它入库单编号"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
						</Col>
						<Col :lg="8" :md="24">
						<FormItem label="操作员" style="width:100%">
							<Input type="text" v-model="searchItems.userName" placeholder="请输入操作员"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
						</Col>
						<Col :lg="8" :md="24">
						<FormItem label="业务日期" style="width:100%" transfer='true'>
							<DatePicker ref="searchBusinessDate" type="daterange" show-week-numbers
								placement="bottom-end" placeholder="请选择日期" @on-change='businessDateChange'
								style="width:100%">
							</DatePicker>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="16" v-show="advancedSelect">
						<Col :lg="8" :md="24">
						<FormItem label="调拨单状态" style="width:100%">
							<Select v-model="searchItems.checkState" @on-change="initListData(1)">
								<Option :value="-1" :key="-1">请选择</Option>
								<Option :value="1" :key="1">已创建</Option>
								<Option :value="2" :key="2">已审核</Option>
							</Select>
						</FormItem>
						</Col>
						<Col :lg="8" :md="24">
						<FormItem label="制单日期" style="width:100%">
							<DatePicker ref="searchCreateDate" type="daterange" show-week-numbers placement="bottom-end"
								placeholder="请选择日期" @on-change='createDateChange' style="width:100%">
							</DatePicker>
						</FormItem>
						</Col>
						<Col :lg="8" :md="24">
						<FormItem label="备注" style="width:100%">
							<Input type="text" v-model="searchItems.note" placeholder="请输入备注"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
						</Col>
					</Row>
					<FormItem :label-width="20">
						<button class="jxyd-button jxyd-primary" @click="initListData(1)"
							style="margin-right:10px;">查询</button>
						<button class="jxyd-button" @click="initSearch" style="margin-right:10px;">重置</button>
						<span @click="advancedSelect = true;" style="color:red;cursor: pointer;" v-if="!advancedSelect">
							展开
							<Icon type="ios-arrow-down" size='18' />
						</span>
						<span @click="foldSearch" style="color:red;cursor: pointer;" v-else>
							折叠
							<Icon type="ios-arrow-up" size='18' />
						</span>
					</FormItem>
				</Form>
			</div>
			<div id="box-table">
				<Table row-key="guid" ref="enterStoreList" :columns="tableColumns" :data="enterStoreListData"
					@on-selection-change="enterStoreListSeleChange"></Table>
			</div>
			<div id="page-box">
				<Page show-sizer :total="enterStoreListCount" :page-size="searchItems.pageSize" @on-change="pageChange"
					show-total show-elevator :page-size-opts='pageSizeOpts' :current="searchItems.pageIndex"
					@on-page-size-change='pageSizeChange'>
				</Page>
			</div>
		</div>
		<ProcessLog :isShow.sync='isShowProcessLog' :processFlowData='processLog'></ProcessLog>
		<div id="hiprint-printTemplate" class="designer-canvas"></div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatDate from '@/utils/formatDate'
	import ProcessLog from '@/components/ProcessLog'
	import printMixin from '@/mixins/printMixin'   // 引入打印 mixin
	export default {
		name: 'enterstorelist',
		mixins:[printMixin],
		components: {
			ProcessLog
		},
		data() {
			return {
				searchItems: {
					code: '',
					userName: '',
					note: '',
					businessDate: [],
					checkState: -1,
					createDate: [],
					pageSize: 10,
					pageIndex: 1
				},
				advancedSelect: false,
				enterStoreListCount: 0,
				tableColumns: [{
						type: 'selection',
						width: 60,
						align: 'center',
						fixed: 'left'
					},
					{
						title: '单据编号',
						key: 'code',
						width: 200,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'enterstorelistdetail',
											query: {
												enterStoreListId: params.row.id
											}
										});
									}
								}
							}, " " + params.row.code)
						}
					},
					{
						title: '业务日期',
						key: 'businessDate',
						width: 200,
						render: (h, params) => {
							return h('span', {}, formatDate(new Date(params.row.businessDate), 'yyyy-MM-dd'));
						}
					},
					{
						title: '业务员',
						key: 'userName',
						width: 200,
					},
					{
						title: '制单日期',
						key: 'createDate',
						width: 150,
						render: (h, params) => {
							return h('span', {}, formatDate(new Date(params.row.createDate), 'yyyy-MM-dd'));
						}
					},
					{
						title: '单据状态',
						key: 'checkState',
						width: 150,
						align: 'center',
						render: (h, params) => {
							switch (params.row.checkState) {
								case 1:
									return h('Tag', {
										style: {},
										attrs: {
											color: 'magenta'
										}
									}, '已创建');
								case 2:
									return h('Tag', {
										style: {},
										attrs: {
											color: 'red'
										}
									}, '已审核');
								case 3:
									return h('Tag', {
										style: {},
										attrs: {
											color: 'success'
										}
									}, '已完结');
							}
						}
					},
					{
						title: '备注',
						key: 'note',
						width: 400
					},
					{
						title: '操作',
						key: 'action',
						width: 180,
						align: 'center',
						fixed: 'right',
						render: (h, params) => {
							var btnArr = [];
							if (params.row.checkState == 1 && this.permission.isAudit) {
								btnArr.push(h('a', {
									class: 'jxyd-a',
									style: {
										'margin-right': '5px'
									},
									on: {
										click: (val) => {
											this.auditEnterStoreList(params.row.id);
										}
									}
								}, '审核'));
							}
							if (params.row.checkState == 2 && this.permission.isRollback) {
								btnArr.push(h('a', {
									class: 'jxyd-a',
									style: {
										'margin-right': '5px'
									},
									on: {
										click: (val) => {
											this.auditEnterStoreList(params.row.id);
										}
									}
								}, '回滚'));
							}
							btnArr.push(h('a', {
								class: 'jxyd-a',
								on: {
									click: (val) => {
										this.initProcessLog(params.row.id);
									}
								}
							}, '操作环节'));
							return btnArr;
						}
					}
				],
				enterStoreListData: [],
				tableRowIds: [],
				tableRowObjs: [],
				isShowProcessLog: false,
				processLog: [],
				permission: {
					isAdd: false,
					isEdit: false,
					isDelete: false,
					isAudit: false,
					isBatchAudit: false,
					isPrint: false,
					isRollback: false,
					isExport: false,
					isBatchPrint: false
				},
				pageSizeOpts: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
			}
		},
		methods: {
			initListData(index) {
				let self = this;
				self.searchItems.pageIndex = index;
				request.post('/api/EnterStoreList/GetEnterStoreList', self.searchItems).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}

					self.enterStoreListData = response.data.enterStoreList;
					self.enterStoreListCount = response.data.count;
				}).catch(function(error) {})
			},
			enterStoreListSeleChange(items) {
				this.tableRowIds = [];
				this.tableRowObjs = items;
				for (var i = 0; i < items.length; i++) {
					this.tableRowIds.push(items[i].id);
				}
			},
			deleteEnterStoreList() {
				if (this.tableRowIds.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '没有选中记录！'
					});
					return;
				}
				var self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: "单据删除后不可恢复，是否继续操作？",
					onOk() {
						request.post('/api/EnterStoreList/DeleEnterStoreList', self.tableRowIds).then(function(
							response) {

							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}

							//记录其它入库单日志
							let logList = [];

							for (var i = 0; i < self.enterStoreListData.length; i++) {
								if (self.tableRowIds.indexOf(self.enterStoreListData[i].id) > -1) {
									logList.push({
										FlowId: self.enterStoreListData[i].id,
										Title: '其它入库单日志',
										OperationContent: '删除了“' + self.enterStoreListData[i]
											.code +
											'”其它入库单',
										Operator: parseInt(localStorage.getItem("userId")),
										State: 1,
										Creator: parseInt(localStorage.getItem("userId"))
									});
								}
							}
							request.post('/api/ProcessLog/AddProcessLog', logList).then(function(
								response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})

							self.initListData(1);
							self.tableRowIds = [];
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			pageChange(index) {
				this.initListData(index);
			},
			foldSearch() {
				this.advancedSelect = false;
				this.searchItems.checkState = -1;
				this.$refs.searchBusinessDate.handleClear();
				this.$refs.searchCreateDate.handleClear();
			},
			initSearch() {
				this.searchItems.code = '';
				this.searchItems.userId = '';
				this.searchItems.userName = '';
				this.searchItems.note = '';
				this.searchItems.checkState = -1;
				this.searchItems.note = '';
				this.$refs.searchBusinessDate.handleClear();
				this.$refs.searchCreateDate.handleClear();
			},
			initProcessLog(id) {
				let self = this;
				request.post('/api/ProcessLog/GetProcessLogList', {
					id: id,
					title: "其它入库单日志"
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取环节日志失败：" + response.errorMsg
						});
						return;
					}

					self.processLog = response.data;
					self.isShowProcessLog = true;
				}).catch(function(error) {})
			},
			addEnterStoreList() {
				this.$router.push({
					path: 'enterstorelistfunc'
				});
			},
			auditEnterStoreList(enterStoreListId) {
				this.$router.push({
					path: 'enterstorelistfunc',
					query: {
						enterStoreListId: enterStoreListId
					}
				});
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['EnterStoreList.Add', 'EnterStoreList.Edit', 'EnterStoreList.Delete',
						'EnterStoreList.Audit', 'EnterStoreList.BatchAudit', 'EnterStoreList.Print',
						'EnterStoreList.Rollback', 'EnterStoreList.Export', 'EnterStoreList.BatchPrint'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if (tipTimeoutCount != undefined) {
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					} else if (response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)) {
						self.$Modal.warning({
							title: '系统到期提示',
							content: response.errorMsg,
							onOk: () => {
								localStorage.setItem("_tipTimeoutCount", 1);
							}
						});
					}
					if (tipTimeoutCount == undefined || tipTimeoutCount < 1000) {
						localStorage.setItem("_tipTimeoutCount", tipTimeoutCount == undefined ? 1 :
							tipTimeoutCount + 1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'EnterStoreList.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'EnterStoreList.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'EnterStoreList.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'EnterStoreList.Audit':
								self.permission.isAudit = response.data[i].permission
								break;
							case 'EnterStoreList.BatchAudit':
								self.permission.isBatchAudit = response.data[i].permission
								break;
							case 'EnterStoreList.Print':
								self.permission.isPrint = response.data[i].permission
								break;
							case 'EnterStoreList.Rollback':
								self.permission.isRollback = response.data[i].permission
								break;
							case 'EnterStoreList.Export':
								self.permission.isExport = response.data[i].permission
								break;
							case 'EnterStoreList.BatchPrint':
								self.permission.isBatchPrint = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			handleDownLoad() {
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: "是否导出列表数据？",
					onOk() {
						fetch('/api/Util/ExportEnterStoreListExcel', {
								method: 'POST',
								headers: new Headers({
									'Authorization': window.localStorage.getItem('token'),
									'Schema': window.localStorage.getItem('schema'),
									'WorkShop': window.localStorage.getItem('workshop'),
									'Content-Type': 'application/json;charset=UTF-8',
									'Accept': 'application/octet-stream' // 明确接受二进制流
								}),
								body: JSON.stringify(self.searchItems)
							})
							.then(res => res.blob())
							.then(data => {
								const blobUrl = window.URL.createObjectURL(data);
								self.download(blobUrl);
							});
					},
					onCancel() {}
				});
			},
			download(blobUrl) {
				const a = document.createElement('a');
				a.download = '其它入库单' + '.xlsx';
				a.href = blobUrl;
				a.click();
			},
			batchPrint() {
				if (this.tableRowIds.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '没有选中记录！'
					});
					return;
				}
				var self = this;
				request.post('/api/EnterStoreList/GetCompleteList', this.tableRowIds).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取全数据列表失败：" + response.errorMsg
						});
						return;
					}
				    // 准备打印数据（原 packPrintData 逻辑不变）
				    const printData = self.formatPrintData(response.data)
				    // 使用 mixin 提供的打印方法
				    self.printWithTemplate(printData, 'enterStoreList')
				}).catch(function(error) {})
			},
			formatPrintData(rawData) {
			  // rawData 已经是数组
			  if (!Array.isArray(rawData)) {
			    console.error('formatPrintData: rawData 不是数组', rawData);
			    return [];
			  }
			  
			  // 辅助函数：添加序号
			  const addSerialNo = (arr) => arr.map((item, idx) => ({ ...item, serialNo: idx + 1 }));
			  
			  // 辅助函数：安全获取数值
			  const safeNumber = (value) => {
			    const num = Number(value);
			    return isNaN(num) ? 0 : num;
			  };
			  
			  // 辅助函数：计算合计
			  const calcTotals = (arr, fields) => {
			    if (!Array.isArray(arr) || arr.length === 0) {
			      const emptyTotals = {};
			      fields.forEach(f => { emptyTotals[f] = 0; });
			      return emptyTotals;
			    }
			    
			    const totals = {};
			    fields.forEach(f => { totals[f] = 0; });
			    
			    arr.forEach(item => {
			      fields.forEach(f => {
			        totals[f] += safeNumber(item[f]);
			      });
			    });
			    
			    return totals;
			  };
			  
			  // 格式化日期
			  const formatDate = (dateStr) => {
			    if (!dateStr) return '';
			    if (dateStr instanceof Date) {
			      const year = dateStr.getFullYear();
			      const month = String(dateStr.getMonth() + 1).padStart(2, '0');
			      const day = String(dateStr.getDate()).padStart(2, '0');
			      return `${year}-${month}-${day}`;
			    }
			    if (typeof dateStr === 'string') {
			      // 处理 "2026-03-19 00:00:00" 或 "2026-03-19" 格式
			      return dateStr.split(' ')[0];
			    }
			    return '';
			  };
			  
			  // 获取商品单价（从商品信息中获取）
			  const getCommodityPrice = (item) => {
			    // 优先使用商品信息中的零售价
			    if (item.commodity && item.commodity.retailPrice) {
			      return safeNumber(item.commodity.retailPrice);
			    }
			    // 如果有价格字段
			    if (item.price) {
			      return safeNumber(item.price);
			    }
			    return 0;
			  };
			  
			  // 格式化单条其它入库单记录
			  const formatSingle = (record) => {
			    if (!record) return {};
			    
			    // 格式化商品入库明细
			    let commodityRaw = (record.enterStoreDetailList || []).map(item => ({
			      name: item.name || '',
			      format: item.format || '',
			      unit: item.unit || '',
			      quantity: safeNumber(item.quantity),
			      price: getCommodityPrice(item),
			      depotName: item.depotName || '',  // 入库仓库
			      batchCode: item.batchCode || '',   // 批次码
			      sellByDate: item.sellByDate && item.sellByDate[0] ? formatDate(item.sellByDate[0]) : '' // 保质期
			    }));
			    
			    // 添加序号
			    let commodityStockDetail = addSerialNo(commodityRaw);
			    
			    // 添加合计行（数量和金额合计）
			    if (commodityRaw.length > 0) {
			      const totals = calcTotals(commodityRaw, ['quantity']);
			      // 计算总金额
			      const totalAmount = commodityRaw.reduce((sum, item) => sum + (item.quantity * item.price), 0);
			      commodityStockDetail.push({
			        serialNo: '',
			        name: '',
			        format: '',
			        unit: '合计',
			        quantity: totals.quantity,
			        price: '',
			        depotName: '',
			        batchCode: '',
			        sellByDate: '',
			        totalAmount: totalAmount,
			        __style__: { fontWeight: 'bold', backgroundColor: '#f9f9f9' }
			      });
			    }
			    
			    // 返回格式化后的数据
			    return {
			      code: record.code || '',
			      userName: record.userName || '',
			      businessDate: formatDate(record.businessDate),
			      note: record.note || '',
			      commodityStockDetail: commodityStockDetail
			    };
			  };
			  
			  // 直接返回格式化后的数组
			  return rawData.map(record => formatSingle(record));
			},
			batchFunc(name) {
				switch (name) {
					case 'batchDele':
						this.deleteEnterStoreList();
						break;
					case 'batchAudit':
						this.checkEnterStoreList(this.tableRowIds, '其它入库单审核后不可更改，内容不可编辑，是否继续操作？');
						break;
					case 'setPrintTemp':
						this.setPrintTemp();
						break;
					case 'batchPrint':
						this.batchPrint();
						break;
				}
			},
			setPrintTemp() {
				this.goSetPrintTemplate('printerpage', {
					printType: 'enterStoreList'
				})
			},
			checkEnterStoreList(ids, func) {
				var self = this;
				if (ids.length <= 0) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}
				let array = [];
				for (var i = 0; i < ids.length; i++) {
					for (var j = 0; j < self.enterStoreListData.length; j++) {
						if (self.enterStoreListData[j].id == ids[i]) {
							if (self.enterStoreListData[j].checkState != 1) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: "选中记录中包含不可审核的数据！"
								});
								return;
							}
							array.push({
								id:ids[i],
								state:2
							})
						}
					}
				}
				this.$Modal.confirm({
					title: "操作警告",
					content: func,
					onOk() {
						request.post('/api/EnterStoreList/CheckEnterStoreList', array).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}
							var log = [];
							for (var i = 0; i < ids.length; i++) {
								//记录采购单操作
								log.push({
									FlowId: ids[i],
									Title: '其它入库单日志',
									OperationContent: '审核了此其它入库单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}

							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})

							self.initListData(1);
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '审核成功!'
							});
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			businessDateChange(val) {
				if (val[0]) {
					this.searchItems.businessDate = val;
				} else {
					this.searchItems.businessDate = [];
				}
			},
			createDateChange(val) {
				if (val[0]) {
					this.searchItems.createDate = val;
				} else {
					this.searchItems.createDate = [];
				}
			},
			pageSizeChange(pageSize) {
				this.searchItems.pageSize = pageSize;
				this.initListData(1);
			},
			getCurrentIntoPrice(data){
				let items = data.format.split(',');
				if(items.length <= 0){
					return 0;
				}
				let priceTypeGroup = data.commodity
					.commodityPriceTypeGroups.find(m=>m.groupName == items[0]);
				if (!priceTypeGroup || priceTypeGroup.commodityPriceTypes.length<=0) {
					return 0;
				}
				let priceType = priceTypeGroup.commodityPriceTypes.find(m=>m.priceType == items[1]);
				if(!priceType){
					return 0;
				}
				let unitData = this.getUnitData(data,data.unit);
				if(!unitData){
					return 0;
				}
				return formatNum(priceType.intoPrice / unitData.conversionRate);
			},
			getUnitData(detail,unitName) {
				if (detail.commodity.extraUnits) {
					let unit = detail.commodity.extraUnits.find(m => m.unit == unitName);
					if (unit) {
						return unit;
					}
				}
				return null;
			},
		},
		watch: {},
		created: function() {
			this.initListData(1);
			this.initPermission();
		}
	}
</script>

<style scoped>
	.layout {
		background: #fff;
		border-radius: 8px;
		padding: 5px 10px;
	}

	#layout-title {
		overflow: hidden;
		padding: 5px;
		font-size: 16px;
		border-bottom: 1px solid #e8eaec;
	}

	#box-search {
		padding-top: 20px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	#page-box {
		margin-top: 20px;
		text-align: center;
	}

	.key {
		text-align: center;
		width: 15%;
		color: #353535;
		font-weight: 400;
	}

	.icon-btn {
		float: right;
		cursor: pointer;
		margin-left: 15px;
		background-color: #F8F8F8;
	}

	.ivu-modal-header p,
	.ivu-modal-header-inner {
		height: auto;
	}

	.time {
		font-size: 14px;
		font-weight: bold;
	}

	.content {
		padding-left: 5px;
	}

	.dropdown-item {
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>